<template>
	<div class="above">
		<card style="margin-bottom: 20px;">
			<Row style="padding-top: 20px;">

				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }" v-if="userInfo.role_type == 1">
				<div class="input-group">
					<span class="input-group-addon">分公司选择</span>
					<Select  v-model="followShop" @on-change="mySearch"
						style="width:150px;" placeholder="分公司" >
						<Option v-for="item in shopList" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
				</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">部门选择</span>
					<Select  v-model="followDepartment" @on-change="mySearch"
						style="width:150px;" placeholder="部门" >
						<Option v-for="item in departmentList" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
				</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">客户经理</span>
					<Select  v-model="followUid" @on-change="mySearch"
						style="width:150px;" placeholder="客户经理" >
						<Option v-for="item in departmentList" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
				</div>
				</Col>
			</Row>
			<Row style="padding-top: 20px;">
				<Col >
					<Button @click="initSearch" type="primary" style="margin-left: 20px;">重置刷新</Button>
				</Col>
			</Row>
			</card>
		<div class="above-box">
        	<div class="above-ch-top">
              <a href="/manage/kefu_statistics/index.html" class="above-more">More</a> 
            	<i class="icon-ui"></i>今日概况<span @click="initSearch" class="icon-ui icon-refresh ml10"></span>
            </div>
            <div class="above-ch-below">
            	<table  width="100%" border="0" cellspacing="0" cellpadding="0"  class="table-style">
           			<tbody>
						<tr>
		                  <td rowspan="4" width="10%">今<br/>日<br/>工<br/>作</td>
		           		  <th width="17%">新申请</th>
		                  <th width="17%">未处理</th>
		                  <th width="17%">再分配</th>
		                  <th width="17%">未处理</th>
		                  <th width="17%">进件笔数</th>
		           		</tr>
		           		<tr>
		                  <td @click.stop="clientClick('today',1,0,'',3)" style="color:#63B3E6;cursor: pointer;">{{today.new_applied_num}}</td>
		                  <td @click.stop="clientClick('today',1,0,1,3)" style="color:#63B3E6;cursor: pointer;">{{today.untreated_new_applied_num}}</td>
		                  <td @click.stop="clientClick('today',2,1,'',5)" style="color:#63B3E6;cursor: pointer;">{{today.redistribution_num}}</td>
		                  <td @click.stop="clientClick('today',2,1,1,5)" style="color:#63B3E6;cursor: pointer;">{{today.untreated_redistribution_num}}</td>
		                  <td @click.stop="clientClickToSignList('today',1)" style="color:#63B3E6;cursor: pointer;">{{today.into_num}}</td>
		                </tr>
		                <tr>
		                  <th width="17%">进件金额</th>
		                  <th width="17%">批款笔数</th>
		                  <th width="17%">批款金额</th>
		                  <th width="17%">创收</th>
		                  <th width="17%">已确认业绩</th>
		           		</tr>
		           		<tr>
		                  <td @click.stop="clientClickToSignList('today',2)" style="color:#63B3E6;cursor: pointer;">{{today.loans_money}}</td>
		                  <td @click.stop="clientClickToSignList('today',2)" style="color:#63B3E6;cursor: pointer;">{{today.loan_num}}</td>
		                  <td @click.stop="clientClickToSignList('today',4)" style="color:#63B3E6;cursor: pointer;">{{today.get_money}}</td>
		                  <td @click.stop="clientClickToSignList('today',4)" style="color:#63B3E6;cursor: pointer;">{{today.repay_money}}</td>
		                  <td @click.stop="clientClickToSignList('today',4)" style="color:#63B3E6;cursor: pointer;">{{today.repay_money}}</td>
		                </tr>
           			</tbody>
              	</table>
              <table  width="100%" border="0" cellspacing="0" cellpadding="0"  class="table-style">
              <tbody>
                <tr>
                  <td rowspan="4" width="10%">昨<br/>天<br/>工<br/>作</td>
                  <th width="17%">新申请</th>
                  <th width="17%">未处理</th>
                  <th width="17%">再分配</th>
                  <th width="17%">未处理</th>
                  <th width="17%">进件笔数</th>
                </tr>
				<tr>
				  <td @click.stop="clientClick('yesterday',1,0)" style="color:#63B3E6;cursor: pointer;">{{yesterday.new_applied_num}}</td>
				  <td @click.stop="clientClick('yesterday',1,0,1)" style="color:#63B3E6;cursor: pointer;">{{yesterday.untreated_new_applied_num}}</td>
				  <td @click.stop="clientClick('yesterday',2,1)" style="color:#63B3E6;cursor: pointer;">{{yesterday.redistribution_num}}</td>
				  <td @click.stop="clientClick('yesterday',2,1,1)" style="color:#63B3E6;cursor: pointer;">{{yesterday.untreated_redistribution_num}}</td>
				  <td @click.stop="clientClickToSignList('yesterday',1)" style="color:#63B3E6;cursor: pointer;">{{yesterday.into_num}}</td>
				</tr>
                <tr>
                  <th width="17%">进件金额</th>
                  <th width="17%">批款笔数</th>
                  <th width="17%">批款金额</th>
                  <th width="17%">创收</th>
		          <th width="17%">已确认业绩</th>
           		</tr>
				<tr>
				  <td @click.stop="clientClickToSignList('yesterday',2)" style="color:#63B3E6;cursor: pointer;">{{yesterday.loans_money}}</td>
				  <td @click.stop="clientClickToSignList('yesterday',2)" style="color:#63B3E6;cursor: pointer;">{{yesterday.loan_num}}</td>
				  <td @click.stop="clientClickToSignList('yesterday',4)" style="color:#63B3E6;cursor: pointer;">{{yesterday.get_money}}</td>
				  <td @click.stop="clientClickToSignList('yesterday',4)" style="color:#63B3E6;cursor: pointer;">{{yesterday.repay_money}}</td>
				  <td @click.stop="clientClickToSignList('yesterday',4)" style="color:#63B3E6;cursor: pointer;">{{yesterday.repay_money}}</td>
				</tr>
              </tbody>
              </table>
              <table  width="100%" border="0" cellspacing="0" cellpadding="0"  class="table-style">
                <tbody><tr>
                <td rowspan="2" width="20%">主管点评</td>
                  <th width="40%">累计点评</th>
                  <th width="40%">未回复</th>
                </tr>
              <tr>
                  <td><a href="/manage/kefu_statistics/bulletin_detail_list.html?type=reviews">0</a></td>
                  <td><a href="/manage/kefu_statistics/bulletin_detail_list.html?type=notreviews">0</a></td>
                </tr>
              </tbody>
              </table>
            	
            </div>
        </div>
        <div class="above-box">
        <div class="r-content">
        	<div class="above-ch-top">
          <a href="/manage/kefu_statistics/month_list.html" class="above-more">More</a> 
          <i class="icon-ui"></i>本月工作<a href="/manage/kefu_common/clearCache.html?cacheKey=<{$cacheKey}>" class="icon-ui icon-refresh ml10"></a>
            </div>
        	<div class="above-ch-below">
            <table  width="100%" border="0" cellspacing="0" cellpadding="0"  class="table-style">
                <tbody>
	                <tr>
	                  <th width="20%">新申请</th>
	                  <th width="20%">未处理</th>
	                  <th width="20%">再分配</th>
	                  <th width="20%">未处理</th>
	                  <th width="20%">已签约</th>
	                </tr>
					<tr>
					  <td @click.stop="clientClick('thismonth',1,0,3,3)" style="color:#63B3E6;cursor: pointer;">{{thismonth.new_applied_num}}</td>
					  <td @click.stop="clientClick('thismonth',1,0,1,3)" style="color:#63B3E6;cursor: pointer;">{{thismonth.untreated_new_applied_num}}</td>
					  <td @click.stop="clientClick('thismonth',2,1,'',5)" style="color:#63B3E6;cursor: pointer;">{{thismonth.redistribution_num}}</td>
					  <td @click.stop="clientClick('thismonth',2,1,1,5)" style="color:#63B3E6;cursor: pointer;">{{thismonth.untreated_redistribution_num}}</td>
					  <td @click.stop="clientClickToSignList('thismonth',1)" style="color:#63B3E6;cursor: pointer;">{{thismonth.sign_num}}</td>
					</tr>
              	</tbody>
              </table>
              <table  width="100%" border="0" cellspacing="0" cellpadding="0"  class="table-style">
                <tbody>
	                <tr>
	                 <!--  <th width="25%">已放款</th> -->
	                  <th width="20%">进件笔数</th>
	                  <th width="20%">进件金额</th>
	                  <th width="20%">批款笔数</th>
	                  <th width="20%">批款金额</th>
	                  <th width="20%">创收</th>
	                </tr>
					<tr>
					  <td @click.stop="clientClickToSignList('thismonth',2)" style="color:#63B3E6;cursor: pointer;">{{thismonth.into_num}}</td>
					  <td @click.stop="clientClickToSignList('thismonth',2)" style="color:#63B3E6;cursor: pointer;">{{thismonth.loans_money}}</td>
					  <td @click.stop="clientClickToSignList('thismonth',4)" style="color:#63B3E6;cursor: pointer;">{{thismonth.loan_num}}</td>
					  <td @click.stop="clientClickToSignList('thismonth',4)" style="color:#63B3E6;cursor: pointer;">{{thismonth.get_money}}</td>
					  <td @click.stop="clientClickToSignList('thismonth',4)" style="color:#63B3E6;cursor: pointer;">{{thismonth.repay_money}}</td>
					</tr>
              	</tbody>
              </table>
              <!--table  width="60%" border="0" cellspacing="0" cellpadding="0"  class="table-style">
                <tbody>
	                <tr>
	                  <th width="20%">未确认业绩</th>
	                  <th width="20%">已确认业绩</th>
	                  <th width="20%">本月未过<br>考核人数</th>
	                  <th width="20%">系统暂停<br>顾问人数</th>
					  <th width="20%">本月原始<br>分配数</th>
	                </tr>
	              	<tr>
	              	  <td><a href="/manage/kefu_trialclients/list_dailysimple.html?date=month&tj_type=wqryj">0</a></td>
	                  <td><a href="/manage/kefu_trialclients/list_dailysimple.html?date=month&tj_type=qryj">0</a></td>
	                  <td><a href="/manage/kefu_dailysimple/noassessment_performance_list.html">0</a></td>
	                  <td><a href="/manage/kefu_dailysimple/system_stop_list.html">0</a></td>
					  <td><a href="/manage/kefu_rankinglist/user_first_situation.html?month=month&spl=1&stime=<{$montharr.stime}>&etime=<{$montharr.etime}>"><{$month_fst_num}></a></td>
	                </tr>
              	</tbody>
              </table-->
            </div>	
            </div>
        </div>
		<div class="above-box">
        <div class="r-content">
			<div class="above-ch-top">
            	<i class="icon-ui"></i>本周概况（{{firstDay}}/{{endDay}}）
            </div>
        	<div class="above-ch-below" style="height:200px;">
            <table  width="100%" border="0" cellspacing="0" cellpadding="0"  class="table-style">
                <tbody>
	                <tr>
					  <td rowspan="5" width="10%">本<br/>周<br/>工<br/>作</td>
	                  <th width="17%">新申请</th>
	                  <th width="17%">未处理</th>
	                  <th width="17%">再分配</th>
	                  <th width="17%">未处理</th>
	                  <th width="17%">进件笔数</th>
	                </tr>
					<tr>
					  <td @click.stop="clientClick('week',1,0)" style="color:#63B3E6;cursor: pointer;">{{week.new_applied_num}}</td>
					  <td @click.stop="clientClick('week',1,0,1)" style="color:#63B3E6;cursor: pointer;">{{week.untreated_new_applied_num}}</td>
					  <td @click.stop="clientClick('week',2,1)" style="color:#63B3E6;cursor: pointer;">{{week.redistribution_num}}</td>
					  <td @click.stop="clientClick('week',2,1,1)" style="color:#63B3E6;cursor: pointer;">{{week.untreated_redistribution_num}}</td>
					  <td @click.stop="clientClickToSignList('week',1)" style="color:#63B3E6;cursor: pointer;">{{week.into_num}}</td>
					</tr>
					<tr>
	                  <th width="17%">进件金额</th>
	                  <th width="17%">批款笔数</th>
	                  <th width="17%">批款金额</th>
	                  <th width="17%">创收</th>
					  <th width="17%">已确认业绩</th>
	                </tr>
					<tr>
					  <td @click.stop="clientClickToSignList('week',2)" style="color:#63B3E6;cursor: pointer;">{{week.sign_num}}</td>
					  <td @click.stop="clientClickToSignList('week',2)" style="color:#63B3E6;cursor: pointer;">{{week.loans_money}}</td>
					  <td @click.stop="clientClickToSignList('week',4)" style="color:#63B3E6;cursor: pointer;">{{week.loan_num}}</td>
					  <td @click.stop="clientClickToSignList('week',4)" style="color:#63B3E6;cursor: pointer;">{{week.get_money}}</td>
					  <td @click.stop="clientClickToSignList('week',4)" style="color:#63B3E6;cursor: pointer;">{{week.repay_money}}</td>
					</tr>
              	</tbody>
              </table>
			  <table  width="100%" border="0" cellspacing="0" cellpadding="0"  class="table-style">
                <tbody>
	                <tr>
					  <td rowspan="5" width="10%">周<br/>报</td>
	                  <th width="17%">原始分配数</th>
	                  <th width="17%">3星以上</th>
	                  <th width="17%">3星以上占比</th>
	                  <th width="17%">上门数</th>
	                  <th width="17%">签约数</th>
	                </tr>
	              	<tr>
	                  <td><a href="/manage/kefu_rankinglist/user_first_situation.html?month=week&spl=1&stime=<{$weekdata.stime}>&etime=<{$weekdata.etime}>">0</a></td>
	                  <td><a href="/manage/kefu_statistics/bulletin_detail_list.html?type=star34&date=week">0</a></td>
	                  <td>0</td>
	                  <td><a href="/manage/kefu_rankinglist/visit_list.html?visit_timetype=week&month=week&stime=<{$weekdata.stime}>&etime=<{$weekdata.etime}>&spl=1">0</a></td>
	                  <td><a href="/manage/kefu_statistics/bulletin_detail_list.html?type=contracted&date=week">0</a></td>
	                </tr>
              	</tbody>
              </table>
            </div>	
            </div>
        </div>
		<Modal v-model="clickJumpClientShow" width="1300" height="500">
			<ClickJumpClient ref="ClickJumpClient" :timePeriod="timePeriod" :timeType="timeType" :status="status" :is_redistribution="is_redistribution"></ClickJumpClient>
		</Modal>
	</div>
</template>

<script>
	import TopBar from "../topbar/TopBar.vue"
	import WorkCalendar from './WorkCalendar.vue'
	import {getWorkReportData} from "../../api/statics.js";
	import {mapGetters} from "vuex";
	import {
		getTeamList,
		getDepartmentList,
	} from '@/api/user'
	import {getAllShop} from "../../api/runSet";
	import moment from 'moment'
	import ClickJumpClient from '../client/ClickJumpClient.vue'
	
	export default {
		name: "WorkReport",
		components: {
			TopBar,
			WorkCalendar,
			ClickJumpClient
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		data() {
			return {
				redValue:'',
				blackValue:'',
				elseValue:'',
				newAddShow:false,
				clickJumpClientShow:false,
				timeType:'',
				newAddTime:moment().format('YYYY-MM-DD'),
				today:[],
				yesterday:[],
				week:[],
				thismonth:[],
				firstDay:'',
				endDay:'',
				teamList:[],
				departmentList:[],
				shopList:[],
				followShop:'',
				followDepartment:'',
				followUid:'',
				timePeriod:'',
				timeType:'',
				status:'',
				is_redistribution:'',
			}
		},
		mounted: function () {
			this.firstDay = this.getWeekStartDate();
			this.endDay = this.getWeekEndDate();
			this.loadData();
			this.getList();
		},
		methods: {
			newAddClick() {
				this.newAddShow = true
			},
			async loadData() {
				let that = this;
				var data = {
					token: this.token,
					only_customer: 1
				};
				var data = {
					token: that.token,
					getSelf: 1,
				};
				var res = await getTeamList(that, data);
				if (res.code == 1) {
					that.teamList = res.data.list;
				}
				res = await getDepartmentList(that, data);
				if (res.code == 1) {
					that.departmentList = res.data.list;
				}
				res = await getAllShop(that, data);
				that.shopList = res.data.list;
			},
			clientClick(time,timeType,is_redistribution,status,client_type) {
				//time:时间  today：今天 yesterday:昨天 week:本周 thismonth:本月
				//timeType:时间类型 1：客户申请时间 2：分发时间 3、备注更新时间
				var timePeriod = '';
				if(time == 'today'){
					this.timePeriod = 1;
				}else if(time == 'yesterday'){
					this.timePeriod = 2;
				}else if(time == 'week'){
					this.timePeriod = 3;
				}else if(time == 'thismonth'){
					this.timePeriod = 5;
				}				
				this.$router.push({
				    name: 'ClickJumpClient',
				    query: {
						get_uid:this.userInfo.id,
						timePeriod: this.timePeriod,
						timeType:timeType,
						status:status,
						is_redistribution:is_redistribution,
						client_type:client_type
				    }
				})
				
			},
			clientClickToSignList(time,timeType) {
				//time:时间  today：今天 yesterday:昨天 week:本周 thismonth:本月
				//timeType:时间类型 1：客户申请时间 2：签约创建时间 3、进件时间 4、回款时间
				var timePeriod = '';
				if(time == 'today'){
					timePeriod = 1;
				}else if(time == 'yesterday'){
					timePeriod = 2;
				}else if(time == 'week'){
					timePeriod = 3;
				}else if(time == 'thismonth'){
					timePeriod = 5;
				}
				this.$router.push({
				    name: 'ClickJumpSignClient',
				    query: {
						timePeriod:timePeriod,
						timeType:timeType
				    }
				})
			},
			// 保存
			saveClick() {
				this.newAddShow = false
			},
			// 提交
			submitClick() {
				
			},
			formatDate(date) {
			  var myyear = date.getFullYear();
			  var mymonth = date.getMonth() + 1;
			  var myweekday = date.getDate();
			  if (mymonth < 10) {
			    mymonth = "0" + mymonth;
			  }
			  if (myweekday < 10) {
			    myweekday = "0" + myweekday;
			  }
			  return (myyear + "-" + mymonth + "-" + myweekday);
			},
			getWeekStartDate() {
				var now = new Date(); // 当前日期
				var nowDayOfWeek = now.getDay(); // 今天本周的第几天
				var nowDay = now.getDate()+1; // 当前日
				var nowMonth = now.getMonth(); // 当前月
				var nowYear = now.getYear(); // 当前年
				nowYear += (nowYear < 2000) ? 1900 : 0;
			  var weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek);
			  return this.formatDate(weekStartDate);
			},
			//获得本周的结束日期
			getWeekEndDate() {
				var now = new Date(); // 当前日期
				var nowDayOfWeek = now.getDay(); // 今天本周的第几天
				var nowDay = now.getDate()+1; // 当前日
				var nowMonth = now.getMonth(); // 当前月
				var nowYear = now.getYear(); // 当前年
				nowYear += (nowYear < 2000) ? 1900 : 0;
			  var weekEndDate = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek));
			  return this.formatDate(weekEndDate);
			},
			mySearch(){
				this.getList();
			},
			initSearch(){
				this.followShop = '';
				this.followDepartment = '';
				this.followUid = '';
				this.getList()
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.token = this.token;
				let res = await getWorkReportData(that, data);
				that.today = res.data.today;
				that.yesterday = res.data.yesterday;
				that.week = res.data.week;
				that.thismonth = res.data.thismonth;
				
			},
		}
	}
</script>
<style scoped lang="less">
html, button, input, select, textarea{font-family:"Microsoft YaHei",Arial,sans-serif}
ul,li{margin:0;padding:0}
body{background:#e5e5e5;margin:0;padding:0;width:100%;}
li{list-style:none;}
a{text-decoration:none;}
.ml10{margin-left: 10px;}
.icon-ui{display:inline-block;font-size: 0;overflow: hidden;-webkit-text-size-adjust: none; vertical-align:middle; zoom:1; background-image:url('https://high.daishuyouquan.com/default/manage/images/icon-bg.png'); width:16px; height:16px;bottom:2px;*bottom:0px;position:relative;margin-right:5px;}
.icon-ui:hover{-webkit-animation: icon-ui 0.6s; animation:icon-ui 0.6s;}
@-webkit-keyframes icon-ui{
	0%{-webkit-transform-origin:center center;transform-origin:center center;-webkit-transform:rotate(0);transform:rotate(0);opacity:1}
	180%{-webkit-transform-origin:center center;transform-origin:center center;-webkit-transform:rotate(200deg);transform:rotate(200deg);}
}
.icon-bulletin{background-position: 0 -52px;}
.icon-refresh{background-position: 0 -26px;}
.above{width:100%;min-height:250px;}
.above-box{width:50%;float:left;background:#fff;zoom:1;display:inline;border-bottom: 5px solid #e5e5e5;}
.above-box .r-content{border-left:8px solid #e5e5e5}
.above-ch-top{height:45px;line-height:45px;padding:0 20px;font-size:16px;color:#333;border-bottom: 5px solid #e5e5e5;}
.above-more{float:right;color:#b1b1b1;font-size:14px;height: 45px;}
.above-ch-below{height:330px;padding:8px 20px;}
.above-ch-below table{margin-bottom: 10px;}
.blow{width:99%;height:auto;background:#fff;margin-top:8px;clear: both;}
.record{display:none;overflow: hidden;}
.record li{margin-top:10px;line-height:22px;padding:0 20px;}
.record li a{width:55%;display:inline-block;}
.record li a:hover{text-decoration: underline;}
.record li.on a{color:#f9322e;}
.record li.on span{color:#999999;margin-left:35px;}
.record li em{display:inline-block;height:18px;_height:16px;padding:0 3px;_padding-top:2px;line-height:18px;_line-height:14px;overflow:hidden;vertical-align:text-bottom;color:#fff!important;background:#ee5567;font-size:12px;text-decoration:none;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;font-style:normal;}
.record li.on .lookover{margin-left: 30px; color: #999999;}
.table-style{border-left:1px solid #e5e5e5;border-top:1px solid #e5e5e5;}
.table-style td,.table-style th{border-right:1px solid #e5e5e5;border-bottom:1px solid #e5e5e5;padding:3px 5px; font-size: 12px;font-weight:normal;line-height:20px;text-align: center;}
.table-style th{background-color:#f2f2f2;}
#MyDiv{width:100%;top:80%;}
#MyDiv .popup-content{width:100%;}
#MyDiv .popup-content .popup-show-figure{width:77.5%;}

/* 老样式 */
.ulstyle{font-size:14px;padding:4%;height:200px}
.ulstyle li{float:left;width:auto;height:23px;padding-left:10%;margin:0 0 8px 1%}
.ulstylein{background:url('https://high.daishuyouquan.com/default/manage/images/phonecomein.jpg') no-repeat;margin-left:0}
.ulstyleout{background:url('https://high.daishuyouquan.com/default/manage/images/phonegoout.jpg') no-repeat;margin-left:2%}
.above-ch-below-main{width:100%;margin-top:60px;margin-left:1%}
.above-ch-below-main .wai{float:left;margin-left:6%;font-size:14px;margin-bottom:15px;color:#444445}
.shuzi{font-size:16px}
.subnotice{float:left;width:20%;padding-top:15px}
.subnotice li div{margin-left:4%;color:#fff;width:35%;height:23px;line-height:23px;background:#ee5567;font-size:14px;text-align:center;cursor:pointer;border-radius:5px;}

td{line-height:23px;}
</style>
<style scoped lang="less">
	.work_report {
		width: 100%;
		min-height: 100%;
		background-color: #F5F7F9;
	}
	.topbar{
		display: flex;
		align-items: center;
	}
	.t-red{
		color: #FF342E;
		font-weight: bold;
	}
	.benyue_flex{
		display: flex;
		.flex_span{
			margin-left: 28px;
		}
		.flex_span_two{
			margin-left: 150px;
		}
	}
	.juli{
		margin: 10px 0;
	}
	.yi{
		margin-left: 28px;
	}
</style>
